import * as React from 'react';
import { getSanitizedHTML } from '@/shared/utils/get-sanitized-html';
interface DangerousInnerHTMLProps {
  html: string;
  tagName?: string;
  className?: string;
  style?: any;
  disableSanitization?: boolean;
  suppressHydrationWarning?: boolean;
  onClick?: (event: React.MouseEvent) => void;
}
export const DangerousInnerHTML = React.memo(function DangerousInnerHTML({
  html,
  tagName,
  className,
  style,
  disableSanitization = false,
  suppressHydrationWarning,
  onClick
}: DangerousInnerHTMLProps) {
  return React.createElement(tagName || 'div', {
    dangerouslySetInnerHTML: {
      __html: disableSanitization === true ? html : getSanitizedHTML(html)
    },
    className,
    style: style || {},
    onClick,
    suppressHydrationWarning
  });
});